import { environment } from '@env/environment';
import { Injectable } from "@angular/core";
import { HttpHeaders } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { AuthenticationService } from '../services/authentication.service';

@Injectable({
  providedIn: "root"
})
export class AppConfig {
  public baseUrl = environment.serverUrl;
  public isProduction = environment.production;

  // Agent Profile Page
  // Show more/less limit
  public showMoreLessLimit: number = 200;

  public updateUserActiveIntervalMS: number = 120000;

  public API_URI = {

    // Agent Home/Detail/Result
    searchAgent: "/Agent/Search?pageSize=PAGESZ&searchkwd=KEYWORD&location=LCN&memberNumber=MEMBERNO",
    getAgentDetail: "/Agent/",
    getAgentResult: "/Agent/Search?pageId=PGID&page=PGNO&sortByEntity=PGSORTBY&sortIsAsc=PGSORTASC",
    getAgentSuggestion: "/Agent/Suggestions",  

    // Agent Activity Listing
    importActivityListing: "/Listing/Template",
    downloadListingTemplate: '/Listing/Template',
    uploadimageForCustomListing: "/Listing/LSTACTIVITYID/Image",
    updatelisting: "/Listing/LSTACTIVITYID/Activity",
    getlistingbyid: "/Listing/LSTACTIVITYID/Activity/",
    getActivityListing: "/Listing/Activity",
    deleteActivity: "/Listing/LSTACTIVITYID/Activity",

    // Referral Management
    getReferral: "/Referral/Get",
    saveReferral: "/Agent/Referral",
    getReferralDetails: "/Agent/Referral/",
    downloadReferral: "/Agent/Referral/",
    updateReferralCommission: "/Agent/REFID/Referral",
  
    // Log Activity
    saveLogActivity: '/Tracking/LogActivity',
    GetLogActivity: "/Tracking/Activity",

    // Contact me
    contactMeSave: '/ContactMe/Enquiry',

    // Upload Video
    uploadVideo: '/Agent/Video',
    uploadMultipleVideo: '/Agent/MultipleVideo',

    // Upload Cover Photo
    UploadCoverPhoto: '/Agent/CoverPhoto',

    // Message Draft (Insert/Update/Discard)
    insertUpdateDeleteMessageDraft: '/Message/Draft',

    // Admin report Endpoints
    getAdminReport: '/Admin/Report',

    // MLS Number
    getInsertUpdateMLSNumber: '/Listing/Agent/MlsNumber',

    // Push notification settings
    getStates: '/Agent/State',
    saveNotification: '/PushNotification/Create',
    notificationHistory: '/PushNotification/History',
    deleteNotification: '/PushNotification/Delete',

    // Messages
    getMessages: '/User/Message',
    getMessageById: '/User/Message/[MESSAGEID]',
    deleteMessageById: '/User/Message/[MESSAGEID]',
    readInboxMessage: '/User/Message/Read/[MESSAGEID]',

    // Message Schedule
    createMessageSchedule: '/User/MessageSchedule',
    updateMessageSchedule: '/User/MessageSchedule',
    deleteMessageSchedule: '/User/MessageSchedule/[MESSAGEID]',

    // RecipientFilter
    getRecipientFilter: '/User/MessageSchedule/RecipientFilter',
    getDropdownsFilterList: '/User/MessageSchedule/RecipientFilter',

    // HowDoYouKnow
    getHowDoYouKnow: '/Agent/Recommendation/HowDoYouKnow',

    // Recommend Agent
    createRecommendation: '/Agent/Recommendation',
    deleteRecommendation: '/Agent/Recommendation/[RECOMMENDID] ',
    acceptRecomendation: '/Agent/Recommendation/Status/[RECOMMENDID]/[isAccept]',
    getRecommendation: '/Agent/Recommendation',
    getRecommendationById: '/Agent/Recommendation/[RECOMMENDID]',
    changeRecommendationVisibility: '/Agent/Recommendation/Visibility/[RECOMMENDID]/[IsVisible]',
    reviseRecommendation: '/Agent/Recommendation/Revise',
    askForRevise: '/Agent/Recommendation/AskRevision/[RECOMMENDID]',

    // Admin Message Schedule
    getMessageScheduleList: '/User/MessageSchedule?isPending=',
    getMessageScheduleById: '/User/MessageSchedule/[SCHEDULEID]',

    // Agent Skill
    getSkillList: '/Agent/Skill/SkillList',
    getSkill: '/Agent/Skill',
    addSkill: '/Agent/Skill',
    deleteSkill: '/Agent/Skill/[SKILLID]',

    // Agent Endorse skills
    getAgentEndorseSkills: '/Agent/Skill/Endorse/[AGENTID]',
    postAgentEndorseSkills: '/Agent/Skill/Endorse',
    deleteAgentEndorseSkill: '/Agent/Skill/Endorse/[ID]',

    // Notification
    getNotifications: '/User/Notification',
    readNotification: '/User/Notification/[NOTIFICATIONID]/[ISREAD]',
    getNotificationsCount: '/User/Notification/Count',

    // Inbox
    getInboxCount: '/User/Message/Count',

    // Group
    getGroups: '/Group',
    getGroupById: '/Group/[GROUPID]',
    createGroup: '/Group/Post/[GROUPID]',
    getAssociatedGroups: '/Community/Group/Associated',
    getGroupSetting: '/Community/Group/Setting/[GROUPID]',
    saveGroupSetting: '/Community/Group/Setting',

    // Feeds
    getAssociatedFeeds: '/Community/FeedList',
    getFeedList: '/Community/Feed/[FEEDID]',

    // Post
    getCommunityPost: '/Community/Post?groupId=[GROUPID]&tag=[TAG]',
    getCommunityPostById: '/Community/Post/[POSTID]',
    createCommunityPost: '/Community/Post',
    updateCommunityPost: '/Community/Post',
    deleteCommunityPost: '/Community/Post/[POSTID]',
    trendingPost: '/Community/Post/TrendingPost/[GROUPID]',
    trendingTags: '/Community/Post/TrendingTag/[GROUPID]',

    // Report post
    reportCommunityPost: '/Community/Post/Report/[POSTID]',
    acceptRejectPost: '/Community/Post/Resolve',

    // Mute Post
    muteCommunityPost: '/Community/Group/Post/Mute/[POSTID]/[ISMUTE]',

    // Comment
    getPostComment: '/Community/Post/Comment/[POSTID]',
    getPostCommentById: '/Community/Post/CommentById/[COMMENTID]',
    createPostComment: '/Community/Post/Comment',
    updatePostComment: '/Community/Post/Comment',
    deletePostComment: '/Community/Post/Comment/[COMMENTID]',

    // Likes
    getLikes: '/Community/Post/Like/[POSTID]',
    likeCommunityPost: '/Community/Post/Like',
    dislikeCommunityPost: '/Community/Post/Like/[LIKEID]',

    // Bookmark
    getAllBookmarkedPost: '/Community/Post/Bookmark',
    createBookmark: '/Community/Post/Bookmark',
    deleteBookmark: '/Community/Post/Bookmark/[BOOKMARKID]',

    // Share commnity post
    shareComunityPost: '/Community/Post/Share/[POSTID]',

    // Reported Post
    GetReportedPost: '/Community/Post/Reported',

    // Login User
    getLoginUser: '/User/Me',

    // Direct Chat
    getActiveChat: '/Chat/Active',
    getChatStatus: '/Chat/status',
    getChatById: '/Chat/[CHATID]',
    postChat: '/Chat',
    updateChat: '/Chat',
    deleteChat: '/Chat/[CHATID]',
    readMessage: '/Chat/Read/[CHATID]',
    getArchiveChat: '/Chat/Archive',

    // Sync Data
    syncData: '/Admin/Agent/SyncData?MemberNumber=[MAMBERNUMBER]&startDate=[DATE]',

    // What's New
    systemWhatIsNewFeatureList: '/system/WhatIsNew',
    MarkFeaturePage: '/system/MarkFeaturePage/[PAGEID]'
  };

  public unauthorizedApi = [
    // Agent Home/Detail/Result
    "/api/Agent/Search?pageSize=",
    "/api/Agent/",
    "/api/Agent/Search?pageId=",
    "/api/Agent/Suggestions",
    "/api/Agent/Skill/Endorse/",
  ]

  public agentAuthorizedApi = [
    "POST /api/Agent/Referral",
    "GET /api/Agent/Referral/[REFERRALID]",
    "POST /api/Agent/Video",
    "POST /api/Agent/MultipleVideo",
    "POST /api/Agent/CoverPhoto",
    "POST /api/Agent/[REFERRALID]/Referral",
    "ALL /api/Agent/Recommendation",
    "GET /api/Agent/Skill/SkillList",
    "GET /api/Agent/Skill/GetAgentSkill",
    "POST /api/Agent/Skill/AddAgentSkill",
    "DELETE /api/Agent/Skill/[AGENTSKILLID]",
    "POST /api/Agent/Skill/Endorse",
    "DELETE /api/Agent/Skill/Endorse/[AGENTSKILLENDORSEMENTID]",
    "GET /api/Agent/Skill/EndorseAgent"
  ]

  // Toaster common messages
  public toasterError = "Error !";
  public toasterSuccess = "Success !";
  public toasterInfo = "Info !";
  public toasterWarning = "Warning !";

  constructor(private authService: AuthenticationService) {

    if (this.authService.isUserLoggedIn()) {
      this.SharedComponent.userLoggedIn = this.authService.isUserLoggedIn();
      // this.SharedComponent.userName = this.authService.getUserInformation()["FirstName"] + " " + this.authService.getUserInformation()["LastName"];
    }
  }

  SharedComponent: ISharedModel = {
    userLoggedIn: false,
    userName: null,
    loggedInUserInfo: null,
    notificationCount: 0,
    inboxCount: 0,
    isWhatIsNewVisible: true
  };

  public GetUrl(uri: string) {
    return this.API_URI[uri];
  }

  formatBytes(bytes, decimals) {
    if (bytes === 0) return '0 GB'
    if (isNaN(parseInt(bytes))) return bytes
    if (typeof bytes === 'string') bytes = parseInt(bytes)
    if (bytes === 0) return '0';
    const k = 1000;
    const dm = decimals + 1 || 3;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`;
  }
}

export interface ISharedModel {
  userLoggedIn: boolean;
  userName: string;
  loggedInUserInfo: any;
  notificationCount: number;
  inboxCount: number;
  isWhatIsNewVisible: boolean;
}